var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppdevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 22,
    height: 34,
    rx: 3,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 7.5,
    width: 5,
    height: 1,
    rx: 0.5,
    stroke: "#2E2E2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 23.5,
    width: 15,
    height: 1,
    rx: 0.5,
    stroke: "#2E2E2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 26.5,
    width: 10,
    height: 1,
    rx: 0.5,
    stroke: "#2E2E2E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 30.5,
    width: 21,
    height: 1,
    rx: 0.5,
    stroke: "#2E2E2E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 14,
    height: 9,
    rx: 1,
    stroke: "#C63031",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11L15 20",
    stroke: "#C63031",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11L29 20",
    stroke: "#C63031",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 34,
    width: 2,
    height: 2,
    rx: 1,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdevelopment);
export default __webpack_public_path__ + "static/media/App development.6385cc50bbab219064d83b489211b4a0.svg";
export { ForwardRef as ReactComponent };